import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try { await login(email, password); navigate("/admin"); }
    catch (err) { setError(formatApiError(err)); }
    finally { setBusy(false); }
  };

  return (
    <main data-testid="admin-login-page" className="grain relative grid min-h-screen place-items-center bg-navy px-4">
      <form onSubmit={submit} className="relative z-10 w-full max-w-sm border border-white/10 bg-navy/60 p-10 backdrop-blur-xl">
        <span className="grid h-12 w-12 place-items-center bg-gold text-navy"><Lock className="h-5 w-5" /></span>
        <p className="eyebrow mt-8 text-gold">Espace administrateur</p>
        <h1 className="mt-2 font-display text-2xl font-bold text-white">Connexion</h1>
        <div className="mt-8 space-y-5">
          <input data-testid="login-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className="field text-white placeholder:text-white/40 border-white/20 focus:border-gold" />
          <input data-testid="login-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Mot de passe" className="field text-white placeholder:text-white/40 border-white/20 focus:border-gold" />
        </div>
        {error && <p data-testid="login-error" className="mt-4 text-sm text-red-300">{error}</p>}
        <button data-testid="login-submit-button" disabled={busy} className="btn-white mt-8 w-full justify-center disabled:opacity-60">{busy ? "Connexion…" : "Se connecter"}</button>
      </form>
    </main>
  );
}
